module.exports = __webpack_public_path__ + "img/hr-pipe-to-ground-left.1f3e19c7.png";